import { getCookie } from "cookies-next";
import { COMMONGROUND_SESSION } from "../configs/constants";

const getTokens = () => {
  const accessToken = getCookie(COMMONGROUND_SESSION.token);
  const refreshToken = getCookie(COMMONGROUND_SESSION.refreshToken);
  const impersonationTarget = getCookie(COMMONGROUND_SESSION.impersonationTarget);

  if (accessToken && refreshToken) {
    return {
      accessToken,
      refreshToken,
      impersonationTarget,
    };
  }

  return null;
};

export default {
  getTokens,
};
